import { MinioTLSCache } from "../../../../api/cacheRpcApi";

export const isTLSEnabled = (tlsConfig?: MinioTLSCache) => {
  if (tlsConfig) {
    if (tlsConfig.publicKey?.trim() !== "") {
      return true;
    }
    if (tlsConfig.privateKey?.trim() !== "") {
      return true;
    }
    if (tlsConfig.caPath?.trim() !== "") {
      return true;
    }
    if (tlsConfig.clientAuth) {
      return true;
    }
  }
  return false;
};

export const maxMemoryValue = (value: string) => {
  // We take the unit constant as GiB. This may change in the future
  const vl = value.replace("GiB", "");

  if (isNaN(Number(vl))) {
    return "";
  }

  return vl;
};
